import React from "react";
import translate from "react-i18next/dist/commonjs/translate";

// Components
import SecurityAlertsLastMonthWidget from "./widgets/SecurityAlertsLastMonthWidget";
import SecurityAlertsLastWeekWidget from "./widgets/SecurityAlertsLastWeekWidget";
import IncidentsWidget from "./widgets/IncidentsWidget"; // eslint-disable-line import/no-named-as-default
import SystemStatusWidget from "./widgets/SystemStatusWidget";
import LogSourceWidget from "./widgets/LogsSourceStatusWidget";
import LogsPerDayWidget from "./widgets/LogsDayWidget";
import PageTitle from "../common/text/PageTitle";

const Dashboard = ({ t }) => (
  <div className="main-content">
    <PageTitle text={t("dashboardPageTitle")} />
    <div className="container">
      <div className="row widget-row">
        <div className="col-sm-4">
          <SecurityAlertsLastMonthWidget />
        </div>
        <div className="col-sm-4">
          <SecurityAlertsLastWeekWidget />
        </div>
        <div className="col-sm-4">
          <IncidentsWidget />
        </div>
      </div>

      <div className="row widget-row">
        <div className="col-sm-4">
          <SystemStatusWidget />
        </div>
        <div className="col-sm-4">
          <LogsPerDayWidget />
        </div>
        <div className="col-sm-4">
          <LogSourceWidget />
        </div>
      </div>
    </div>
  </div>
);

export default translate("translations")(Dashboard);



// WEBPACK FOOTER //
// ./src/dashboard/Dashboard.js